import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../assests/images/hero-img1.png";
import { HeaderImg } from "../../Images";
import "./hero-section.css";

const HeroSection = () => {
  const [query, setQuery] = useState("");

  const handleSearch = () => {
    window.location.href = `/certificate/${query}`;
  };

  return (
    <section className="hero__section">
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="hero__content">
              <h2 className="mb-4 hero__title">
                Anytime Anywhere, <br /> check the authenticity <br /> of the
                school certificate
              </h2>
              <p className="mb-5">
                We know that manual verification of a certificate <br /> can be
                stressfull, and because if that <br /> we have developed this
                web to automate that.
              </p>
            </div>
            <div className="search">
              <input
                type="text"
                placeholder="Enter certificate number..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button className="btn" onClick={handleSearch}>
                Search
              </button>
            </div>
          </Col>

          <Col lg="6" md="6" className=" hero__img">
            <img src={HeaderImg} alt="" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
